export const PXAccordionV2 = (function () {
	'use strict';

	let $accordionV2Group;

	function init() {
		$accordionV2Group = $('.pxblock--accordion-v2');
		if (!$accordionV2Group) return null;

		$accordionV2Group.each(function () {
			let $this = $(this);

			let $items = $this.find('.pxblock--accordion-v2__item');
			$items.each(function () {
				let $that = $(this);
				let $panel = $that.find('.pxblock--accordion-v2__item-content');
				$panel.slideUp(1);
			});
		});

		events();
	}

	function events() {
		$accordionV2Group = $('.pxblock--accordion-v2');
		if (!$accordionV2Group) return null;

		$accordionV2Group.each(function () {
			let $this = $(this);
			let $items = $this.find('.pxblock--accordion-v2__item');


			$items.each(function () {
				let $that = $(this);
				let $button = $that.find('button');
				let $panel = $that.find('.pxblock--accordion-v2__item-content');

				$button.on('click', function () {
					let $thisButton = $(this);
					if ($thisButton.attr('aria-expanded') === 'true') {
						$thisButton.attr('aria-expanded', 'false');
						$panel.slideUp();
						$panel.attr('aria-hidden', 'true');
						$that.removeClass('show');
					} else {
						$thisButton.attr('aria-expanded', 'true');
						$panel.slideDown();
						$panel.attr('aria-hidden', 'false');
						$that.addClass('show');
						
					}
				});
			})
		})
	}

	return {
		init: init
	};
})();
